export const ITEM_GAP = 12;
//# sourceMappingURL=constants.js.map